import React from "react";
import Btn from "../../Components/Btn";
import OTP from "../../Components/Form/OTP";
import { Statistic } from "antd";
import { useOTP } from "./Hook";
import { useParams } from "react-router-dom";

const Otp = () => {
  const {
    send,
    loading,
    showResend,
    secondsToTime,
    resendCode,
    loadingResend,
  } = useOTP();

  return (
    <>
      <OTP request={send} />
      <Btn loading={loading} text={"تایید کد ورود"} className="mb-10" />
      <Btn
        loading={loadingResend}
        secondary={true}
        className="fs-10 fw-600 lh-17 "
        onClick={resendCode}
        disabled={!showResend}
        text={() => (
          <>
            {!showResend ? (
              <>
                <p>{`ارسال مجدد کد تایید (${secondsToTime().s} : ${
                  secondsToTime().m
                })`}</p>
              </>
            ) : (
              <>
                <p>{`ارسال مجدد کد تایید`}</p>
              </>
            )}
          </>
        )}
      />
    </>
  );
};

export default Otp;
